import React, { AnchorHTMLAttributes, DetailedHTMLProps } from 'react'

import { pushLinkClick } from '@emico/datalayer'
import { sanitizeURL } from '@emico/url'
import { testId } from '@emico/utils'

interface OwnProps {
  to: string

  // GTM
  /** Tracking event name */
  analyticsName: string
  /** Tracking event category */
  analyticsContext: string
}

export type Props = OwnProps &
  DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>

const isAnalyticsEnabled =
  process.env.REACT_APP_DISABLE_ANALYTICS_LINK_CLICK !== 'true'

const ExternalLink = ({
  to,
  target,
  children,
  analyticsName,
  analyticsContext,
  onClick,
  ...props
}: Props) => (
  <a
    href={sanitizeURL(to)}
    target={target}
    rel={target === '_blank' ? `noopener noreferrer` : undefined}
    data-testid={testId(analyticsName, analyticsContext)}
    onClick={
      isAnalyticsEnabled
        ? (e) => {
            pushLinkClick(analyticsName, analyticsContext, 'external')
            if (onClick) {
              onClick(e)
            }
          }
        : onClick
    }
    {...props}
  >
    {children}
  </a>
)

export default ExternalLink
